import React from "react";

const DashboardSkeleton: React.FC = () => (
  <>
    {/* skeleton stat cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="bg-white rounded shadow p-6 flex items-start gap-4 animate-pulse">
          <div className="bg-gray-200 p-3 rounded-lg w-12 h-12" />
          <div className="flex-1">
            <div className="h-3 bg-gray-200 rounded w-2/3 mb-3" />
            <div className="h-7 bg-gray-200 rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>

    {/* skeleton recent documents */}
    <div className="bg-white rounded shadow mb-12 animate-pulse">
      <div className="px-4 sm:px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <div className="h-4 bg-gray-200 rounded w-48" />
        <div className="h-4 bg-gray-200 rounded w-16" />
      </div>
      <div className="divide-y divide-gray-200">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
            <div className="flex-1">
              <div className="h-4 bg-gray-200 rounded w-1/3 mb-2" />
              <div className="h-3 bg-gray-200 rounded w-1/4" />
            </div>
            <div className="h-5 w-5 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  </>
);

export default DashboardSkeleton;
